import React, { useMemo } from "react";
import DetailsSectionLabel from "./DetailsSectionLabel";
import DetailsTable from "./DetailsTable";

export default function MiscTab({ data }) {
  const salesColumns = useMemo(
    () => [
      {
        label: "Date of Sale",
        key: "DateOfSale",
      },
      { label: "Amount", key: "Amount" },
    ],
    []
  );
  return (
    <>
      <DetailsSectionLabel label="LEGAL DESCRIPTION" isFirst={true} />
      <div className="flex text-xs text-center ml-1">
        {data.LegalDescription}
      </div>
      <DetailsSectionLabel label="SALES" />
      <DetailsTable rows={data.Sales} columns={salesColumns} />
    </>
  );
}
